<template>
	<div id="app2">
		<UserMenu></UserMenu>
		<StyleGuide></StyleGuide>		
	</div>
</template>

<script>
   
    import StyleGuide from '../components/Styleguide/StyleGuide.vue';		
	import UserMenu from '../components/UserMenu.vue';	
   
	
    export default {
        name: 'Styleguide',
		components:
            { StyleGuide , UserMenu },
		mounted: function () {
			
            
		}
    };
</script>

